module.exports = __webpack_public_path__ + "media/images/game/resources/money_tiny-53a1e579513d0d9f9d4a99bb011f63b2.png";